import { render, staticRenderFns } from "./SocialnyPodnikTableUsers.vue?vue&type=template&id=7fa06d88&"
import script from "./SocialnyPodnikTableUsers.vue?vue&type=script&lang=js&"
export * from "./SocialnyPodnikTableUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VDivider,VLayout,VTextField})
